import { Button, DialogBody, Separator, Stack, Text } from "@chakra-ui/react"
import { Form, UI } from "components"
import { toaster } from "config"
import useUser from "hooks/useUser"
import { useState } from "react"
import OneSignal from "react-onesignal"

export default function Notification({ ...props }){

    const user = useUser()
    const [ loading, setLoading ] = useState(false)
    const optedIn = OneSignal.User.PushSubscription.optedIn

    const handlePermission = async () => {
        setLoading(true)

        try{
            
            // Solicita permissão nativa
            await OneSignal.Notifications.requestPermission()
            
            // Verifica se a permissão foi negada
            if(!OneSignal.Notifications.permission){
                toaster.create({ title: 'Não foi possível configurar as notificações. Tente novamente.', type: 'warning' })
                setLoading(false)
                return
            }

            // Realiza vínculo
            await OneSignal.login(user.data?.id)
            
            // Assina opt-in
            await OneSignal.User.PushSubscription.optIn()

            toaster.create({ title: 'Notificações ativadas com sucesso', type: 'success' })
            props.onClose()
        }catch(err){
            console.log(err)
            toaster.create({ title: 'Não foi possível ativar as notificações. Tente novamente.' })
        }

        setLoading(false)
    }

    const toggleOptIn = async () => {
        setLoading(true)
        optedIn ? await OneSignal.User.PushSubscription.optOut() : await OneSignal.User.PushSubscription.optIn()
        setLoading(false)
    }

    return(
    <UI.Dialog size="xs" title="Notificações" {...props}>
        <DialogBody>
            <Stack gap={4}>

                <Text>Mantenha as notificações ativadas para ser avisado de atualizações importantes do seu escritório de consultor.</Text>

                <Separator />

                <UI.Show visible={!OneSignal.Notifications.permission}>
                    <Button colorPalette="orange" loading={loading} loadingText="Autorize a permissão..." onClick={handlePermission}><UI.Icon name="notification" /> Ativar notificações</Button>
                </UI.Show>

                <UI.Show visible={OneSignal.Notifications.permission}>
                    <Button disabled colorPalette="green"><UI.Icon name="check" /> Notificações ativadas</Button>
                </UI.Show>

                <Separator />

                <Form.Checkbox disabled={loading} defaultChecked={optedIn} onChange={toggleOptIn} label="Receber notificações de novidades e promoções da Bonífica para Consultores." />

            </Stack>
        </DialogBody>
    </UI.Dialog>
    )
}